<script setup lang="ts">
import AvatarItem from '@/components/Avatar/AvatarItem.vue'
import { BaseCard } from '@/components/Cards'
import { StackLayout } from '@/components/Layouts'
import TypographyWithPrefix from '@/components/Typography/TypographyWithPrefix.vue'
import TypographyItem from '../../../../Typography/TypographyItem.vue'

type Props = {
    label: string
    prefix?: string
}
defineProps<Props>()
</script>

<template>
    <BaseCard class="user-card">
        <template #title>
            <AvatarItem :name="label" class="user-avatar" />
        </template>
        <template #content>
            <StackLayout direction="column" :gap="8" class="user-card-content">
                <TypographyWithPrefix v-if="prefix" :prefix="prefix" :label="label" />
                <TypographyItem v-else :label="label" />
            </StackLayout>
        </template>
        <template v-if="$slots['footer']" #footer>
            <slot name="footer" />
        </template>
    </BaseCard>
</template>

<style scoped lang="scss">
.network-card {
    border-radius: 100px;
    align-self: center;
    height: 100px;
    width: 100px;
    cursor: pointer;
    & :deep(.card-content) {
        text-align: center;
    }
}
.user-avatar {
    margin: auto;
}
.networks-list {
    flex-flow: wrap;
}
.user-card {
    & :deep(.card-header) {
        height: 36px;
    }
    & :deep(.card-content) {
        margin-top: 8px;
    }
}
</style>
